/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import FormatService from '../../services/format.service';
import { HeroMetricViewModel } from 'src/types/view-models/hero-metric.view.model';
import { MetricModel } from 'src/types/metric.model';
import MoreInfoTooltip from 'src/components/more-info-tooltip/MoreInfoTooltip';

// styles
import styles from './HeroMetric.module.scss';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { TooltipPlacement } from 'src/types/tooltip-placement.enum';
import Selectors from 'src/utils/selectors';

export default class HeroMetric extends Component<HeroMetricViewModel> {
    public override render(): ReactComponentElement<any> {
        const metric: MetricModel = this.props.metric;
        const sign: string = metric.value >= 0 ? '+' : '';
        const classNameType: string = metric.value >= 0 ? 'good' : 'bad';
        const metricValue: string = sign + FormatService.format(metric.value);
        return (
            <div className={styles.metricContainer} data-cy={Selectors.PlanAhead.METRIC_CONTAINER}>
                <div className={styles.metricHeader} data-cy={Selectors.PlanAhead.METRIC_HEADER}>
                    <Typography variant={TypographyVariants.SUBTEXT} className={styles.heading}>
                        {metric.header}
                    </Typography>
                    <MoreInfoTooltip
                        body={metric.tooltip}
                        placement={TooltipPlacement.BOTTOM}
                        width={this.props.tooltipMaxWidth || '260px'}
                        buttonAriaLabel={metric.header}
                    />
                </div>
                {this.props.showChange ? (
                    <Typography
                        variant={TypographyVariants.HEADING_S}
                        className={[classNameType, styles.valueBody].join(' ')}
                    >
                        {metricValue}
                    </Typography>
                ) : (
                    <Typography variant={TypographyVariants.HEADING_S} className={styles.valueBody}>
                        {metricValue}
                    </Typography>
                )}
            </div>
        );
    }
}
